import View from './View'

const Container = ({ admData }) => {
  return <View title="Excluir Condominio" admData={admData} />
}

export default Container
